<template>
  <div>
    <div class="all">
      <div class="my_headers">
        <my_header :msg="title_msg" :states="1"></my_header>
      </div>
      <div class="title">
        <p>筑龙学社课程优惠券</p>
        <p>
          仅剩
          <span>{{ coupon_obj.remain_num }}</span>张
        </p>
      </div>
      <div class="my_coupon">
        <div class="my_couponMain">
          <div class="my_couponMainLeft">
            <p>
              <span>￥</span>
              {{ coupon_obj.money }}
            </p>
            <p>{{ coupon_obj.left_name }}</p>
          </div>
          <div class="my_couponMainright">
            <p>{{ coupon_obj.name }}</p>
            <p>
              <span>有效期至</span>
              {{ coupon_obj.end_time }}
            </p>
          </div>
        </div>
      </div>
      <div class="phone">
        <div class="myPhone">
          <span>+86</span>
          <input v-model="mobile" placeholder="输入您的手机号，领取优惠券" type="number">
        </div>
      </div>
      <div class="my_btn">
        <button @click="GetItNow">立即领取</button>
      </div>
      <div class="foot">
        <p>优惠券属于稀缺资源，若不需要请勿领取</p>
      </div>
    </div>
  </div>
</template>

<script>
import my_header from '@/components/common/heads.vue'
import { getItNow, get_ones_yhq } from '@/api/my_user.js'
import { Toast } from 'vant'
export default {
  components: {
    my_header
  },
  data() {
    return {
      title_msg: '领取优惠卷',
      mobile: '',
      coupon_obj: {}
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      var params = {
        id: this.$route.query.id,
        uid: this.$route.query.uid
        // id:68
      }
      get_ones_yhq(params).then(res => {
        this.coupon_obj = res.result
      })
    },
    GetItNow() {
      if (this.mobile === '') {
        Toast('手机号不能为空')
        return false
      }
      var params = {
        // r_id:275,
        coupon_id: this.$route.query.id,
        uid: this.$route.query.uid,
        mobile: this.mobile
      }
      getItNow(params).then(res => {
        if (res.errNo !== 0) {
          Toast(res.msg)
          // this.$router.push({
          //   path: '/index/coupon/ReceiveResults',
          //   query: {
          //     status: 0,
          //     my_msg: res.msg,
          //     thumb: res.result.thumb,
          //     lessonId: res.result.lesson_id

          //   }
          // })
        } else {
          Toast('领取成功')
          this.$router.push({
            path: '/index/coupon/ReceiveResults',
            query: {
              status: 1,
              thumb: res.result.thumb,
              lessonId: res.result.lesson_id
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my_couponMainright {
  flex: 1;
  height: 100%;
  // background: chartreuse;
  p:nth-child(1) {
    font-size: 30px;
    color: #333333;
    // text-align: center;
    margin: 0 auto;
    width: 82%;
    padding: 25px 0 0 0;
  }
  p:nth-child(2) {
    width: 82%;
    margin: 0 auto;
    padding: 15px 0 0 0;
    color: #333333;
    span {
      padding-right: 20px;
      color: #ee2e2e;
    }
  }
}
.my_couponMainLeft {
  width: 180px;
  height: 100%;
  // background: #e62929;
  p:nth-child(1) {
    color: #fff;
    font-size: 50px;
    text-align: center;
    padding: 40px 0 0 0;
    span {
      font-size: 30px;
    }
  }
  p:nth-child(2) {
    color: #fff;
    padding-top: 20px;
    text-align: center;
  }
}
.my_btn button {
  width: 684px;
  height: 90px;
  margin: 0 auto;
  display: block;
  margin-top: 40px;
  color: #fff;
  background: #e62929;
  border-radius: 13px;
  font-size: 30px;
  letter-spacing: 5px;
}
.foot p {
  font-size: 28px;
  text-align: center;
  padding-top: 10px;
  color: #999999;
}
.myPhone {
  width: 680px;
  height: 86px;
  border: 3px solid #ddd;
  margin: 0 auto;
  border-radius: 13px;
  span {
    line-height: 86px;
    padding-left: 40px;
  }
  input {
    height: 86px;
    padding: 0 0 0 90px;
    width: 500px;
    color: #333;
    font-size: 28px;
  }
}
.my_couponMain {
  display: flex;
  width: 684px;
  height: 181px;
  margin: 0 auto;
  background: url("../../../static/images/my_index/222.png") no-repeat;
  background-size: 100% 100%;
  box-shadow: 0px 3px 35px #e1e1e1;
  margin-top: 30px;
}
.phone {
  width: 100%;
  height: 95px;
  margin: 75px 0 0 0;
}
.all {
  background: url("../../../static/images/my_index/givesbg.png") no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  width: 100%;
  // position: relative;
  // bottom: 30px;
  // overflow: hidden;
}
.my_headers {
  border-bottom: 1px solid #e1e1e1;
}
.title {
  width: 100%;
  height: 185px;
  p:nth-child(1) {
    font-size: 30px;
    text-align: center;
    padding-top: 64px;
    letter-spacing: 2px;
    color: #494949;
  }
  p:nth-child(2) {
    font-size: 35px;
    text-align: center;
    padding-top: 30px;
    color: #494949;
    letter-spacing: 3px;
    span {
      color: #ee2e2e;
      padding: 0 5px;
    }
  }
}
</style>
